module.exports = __webpack_public_path__ + "media/images/smart_phone/portal/slide_05-4eee02d2ea2a6596073abb2b1eaff72b.png";